import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { switchMap } from 'rxjs/operators';
import {
  ReentregaLoteSelecionarInconsistenciaResponse,
  ReentregaLoteSelecionarInconsistenciasRequest,
  ReentregaLoteUploadExcelRequest
} from 'src/app/@shared/models/reentrega-lote/reentrega-lote.model';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { ReentregaLoteService } from 'src/app/services/reentrega-lote/reentrega-lote.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reentrega-lote',
  templateUrl: './reentrega-lote.component.html',
  styleUrls: ['./reentrega-lote.component.scss']
})
export class ReentregaLoteComponent implements OnInit, AfterViewInit {

  isLoading = false;
  isLoadingDownload: boolean;

  filterForm = new FormGroup({
    justificativa: new FormControl('', Validators.required),
  });
  get justificativa() { return this.filterForm.get('justificativa').value; }

  public displayedColumns: string[] = [
    'linhaArquivo',
    'inconsistencia',
  ];

  public reentregaConsultaGrid: MatTableDataSource<ReentregaLoteSelecionarInconsistenciaResponse> =
    new MatTableDataSource<ReentregaLoteSelecionarInconsistenciaResponse>([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  linkTemplate: string;
  filename: string;
  file: File;

  constructor(
    public clienteService: ClienteService,
    public reentregaLoteService: ReentregaLoteService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.reentregaConsultaGrid.paginator = this.paginator;
  }

  async selecionarArquivo(file) {
    if (!this.justificativa) {
      return this.openSnackBar('Preencha o campo Justificativa!', 'OK', 3000, 'warning-snackbar');
    }

    if (file.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      && file.target.files[0].type !== 'application/vnd.ms-excel'
    ) {
      this.filename = '';
      this.file = null;
      return this.openSnackBar(
        'Apenas arquivos .xls ou .xlsx são permitidos!',
        'OK',
        3000,
        'danger-snackbar'
      );
    } else {
      this.filename = file.target.files[0].name;
      this.file = file.target.files[0];
      await this.enviarArquivo(this.file);
    }
  }

  calcularTotal(arr: any, propriedade: string): number {
    return arr.filter(item => item.importacao === propriedade).length
  }

  async enviarArquivo(file) {
    this.isLoading = true;

    const reader = new FileReader();
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      const obj: ReentregaLoteUploadExcelRequest = {
        nomeArquivo: file.name,
        data: reader.result.toString().split(',')[1],
        justificativa: this.justificativa
      }

      this.reentregaLoteService.uploadExcelReentregaLote(obj)
        .pipe(
          switchMap(response => {
            const objInconsistencia: ReentregaLoteSelecionarInconsistenciasRequest = {
              idCapa: response.item2,
              itensPorPagina: 10000,
              paginaAtual: 1
            }
            return this.reentregaLoteService.selecionarInconsistencias(objInconsistencia)
          })
        )
        .subscribe((inconsistencia: ReentregaLoteSelecionarInconsistenciaResponse[]) => {
          if (inconsistencia.length) {
            this.reentregaConsultaGrid.data = inconsistencia;
            this.openSnackBar('O arquivo possui inconsistências.', 'OK', 5000, 'warning-snackbar');
          } else {
            this.openSnackBar('O arquivo NÃO possui inconsistências.', 'OK', 5000, 'success-snackbar');
          }
        },
        (err: HttpErrorResponse) => console.error(err),
        () => this.isLoading = false
      )
    }
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcelTemplate() {
    this.isLoadingDownload = true;
    this.reentregaLoteService.downloadTemplate().subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, {
      duration,
      panelClass
    });
  }
}
